function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

var wFlag=window.innerWidth>750

$(()=>{
    setTimeout(() => {
        $('.box1_title').css({transform:'translateY(0)',opacity:1})
    }, 300);

    ScrollTrigger.create({
        trigger:'.box2_item',
        start:wFlag?'top bottom-=30%':'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box2_item div',{opacity:0,y:'2rem',stagger:0.2})
    })
    showUp('.box3_title')

    ScrollTrigger.create({
        trigger:'.box4',
        start:wFlag?'top top+=10%':'top top+=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .to('.box4_img',{clipPath:wFlag?'inset(20% 23% 20% 23% round 1.5rem)':'inset(22% 5% 13% 5% round 1rem)'})
            .from('.box4_content',{y:'2rem',opacity:0})
    })

    showUp('.box5_title')
    ScrollTrigger.create({
        trigger:'.box5',
        start:'top top+=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .to('.box5_mask',{opacity:1})
    })

    showUp('.box6_title')
    $('.box6_lItem').click(function(){
        var index = $(this).index()
        $(this).addClass('box6Active').siblings().removeClass('box6Active')
        if(index==0){
            $('.box6_right div p img:nth-child(1)').css({opacity:1,transform:'translateY(0%)',transition:'all 1s'})
            $('.box6_right div p img:nth-child(2)').css({opacity:0,transform:wFlag?'translateY(-50%)':'translateY(-30%)',transition:'all 0s'})
        }else{
            $('.box6_right div p img:nth-child(2)').css({opacity:1,transform:'translateY(0%)',transition:'all 1s'})
            $('.box6_right div p img:nth-child(1)').css({opacity:0,transform:wFlag?'translateY(-50%)':'translateY(-30%)',transition:'all 0s'})
        }
    })

    //boxSpecs_btn
    $('.bs_btn').click(function(){
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_buy').click(function(){ 
       //window.open(''); 
    })

    $('.pnr_spec').click(function(){
        $('.Mpn_popup').css({height:'0'})
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_over2').click(function(){
        $('.Mpn_popup').css({height:'0'})
        $('.classic_section2').hide()
        $('.classic_section1').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
    })
})